import { NextPage } from 'next';
import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import Modal from 'componentsUnits/modal';
import ColumnComponent from 'componentsUnits/columnComponent';
import Break from 'componentsUnits/break';
import { usePathname } from 'next/navigation';
import { disabledGoToAppOnPages } from 'helpers/web';
import RowComponent from 'componentsUnits/row';
import { Size } from 'types/size';
import Subtitle from 'componentsUnits/subtitle';

interface Props {
  children: React.ReactNode;
}

const IsWeb: NextPage<Props> = ({ children }) => {
  const isNative = Capacitor.isNativePlatform();
  const [showModal, setShowModal] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // Show modal only if the user is on a web platform and not on disabled pages
    if (!isNative && pathname && !disabledGoToAppOnPages.includes(pathname)) {
      setShowModal(true);
    }
  }, [isNative, pathname]);

  // If the user is on a native platform or a disabled page, render children directly
  if (isNative || (pathname && disabledGoToAppOnPages.includes(pathname))) {
    return <>{children}</>;
  }

  return (
    <div>
      <Modal
        delayInSeconds={60 * 15}
        onClose={() => setShowModal(false)}
        header="brizup on the phone!"
        hidden={!showModal}
        singleUse
      >
        <ColumnComponent centerH centerV>
          <Break />
          <img src="/images/people_dance.png" alt="People dancing" style={{ maxWidth: 250 }} />
          <Break size={Size.small} />
          <Subtitle size={Size.small} text="Try brizup on iOS and Android for a better experience" />
          <Break />
          <RowComponent gap>
            <img
              src="/images/appstore.png"
              alt="App Store"
              width="50%"
              onClick={() => window.open(process.env.IOS_LINK, '_blank')}
              style={{ cursor: 'pointer' }} // Added pointer cursor for better UX
            />
            <img
              src="/images/googleplay.png"
              alt="Google Play"
              width="50%"
              onClick={() => window.open(process.env.ANDROID_LINK, '_blank')}
              style={{ cursor: 'pointer' }} // Added pointer cursor for better UX
            />
          </RowComponent>
          <Break />
        </ColumnComponent>
      </Modal>
      {children}
    </div>
  );
};

export default IsWeb;
